import { Box, Grid } from "@mui/material"

const Tematicas = () => {
    return (
        <>
        <Grid container flexDirection="row" spacing={1}>
            <Grid item xs={4}>
                <img src="/images/tematicas/mesa-1.jpg" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={4}>
                <img src="/images/tematicas/mesa-2.jpg" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={4}>
                <img src="/images/tematicas/mesa-3.jpg" style={{ width: '100%' }} />
            </Grid>
        </Grid>
        <Grid container flexDirection="row" spacing={1}>
            <Grid item xs={4}>
                <img src="/images/tematicas/mesa-4.jpg" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={4}>
                <img src="/images/tematicas/mesa-5.jpg" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={4}>
                <img src="/images/tematicas/mesa-6.jpg" style={{ width: '100%' }} />
            </Grid>
        </Grid>
        </>
    )
}

export default Tematicas